<div class="detalle-beneficiario-container">
  <div style="font-size: 24px; font-weight: bold;">
    Detalle de Beneficiario
  </div>
  <br>
  <nz-spin class="graph-spin" [nzSpinning]="loading"> 
  <div class="informacion-beneficiario">
    <div class="section-header"
    >
      <h3 class="section-title">Información</h3>
      <img
        src="assets/icon/edit.svg"
        class="icono-sgmm edit-icon"
        style="cursor: pointer;"
        alt="icono sgmm"
        (click)="mostrarModal()"
        *ngIf="(user?.esMedico || user?.esRRHH) 
        && beneficiario?.esProcesada && beneficiario?.esVigente
        "
      />
    </div>
    
    <div class="info-row">
      <div class="info-field">
        <span class="field-label">Colaborador:</span>
        <span class="field-value">{{ (beneficiario?.colaboradorNombre || '') + ' ' + (beneficiario?.colaboradorApellidos || '') }}</span>
      </div>
      
      <div class="info-field" *ngIf="beneficiario?.tipoGestacionId != 1">
        <span class="field-label">Beneficiario:</span>
        <span class="field-value">
          {{ (beneficiario?.beneficiarioNombre || 'N/A') }}
        </span>
      </div>
    </div>
    
    <div class="info-row">
      <div class="info-field">
        <span class="field-label">Género Colaborador:</span>
        <span class="field-value">
          <nz-tag [nzColor]="beneficiario?.colaboradorGenero === 'M' ? 'blue' : 'pink'">
            {{ beneficiario?.colaboradorGenero === 'M' ? "Masculino" : "Femenino" }}
          </nz-tag>
        </span>
      </div>
      
      <div class="info-field">
        <span class="field-label">Número de Gestantes:</span>
        <span class="field-value umas-value">
          {{ beneficiario?.numeroGestantes || 0 }}
        </span>
      </div>
    </div>

    <div class="info-row">
      <div class="info-field">
        <span class="field-label">Fecha Inicio:</span>
        <span class="field-value">{{ ( beneficiario?.fechaInicio | date:'dd/MM/yyyy' ) || 'N/A' }}</span>
      </div>
      
      <div class="info-field">
        <span class="field-label">Fecha Fin:</span>
        <span class="field-value">{{ ( beneficiario?.fechaFin | date:'dd/MM/yyyy' ) || 'N/A' }}</span>
      </div>
    </div>

    <div class="info-row">
      <div class="info-field">
        <span class="field-label">Tipo de Gestación:</span>
        <span class="field-value">
          <nz-tag [nzColor]="beneficiario?.tipoGestacion === 'Personal' ? 'green' : 'orange'">
            {{ beneficiario?.tipoGestacion || 'N/A' }}
          </nz-tag>
        </span>
      </div>
      
      <div class="info-field">
        <span class="field-label">Estado de Gestación:</span>
        <span class="field-value">
          <nz-tag [nzColor]="getColor(beneficiario?.estadoGestacion!)">
            {{ beneficiario?.estadoGestacion || 'N/A' }}
          </nz-tag>
        </span>
      </div>
    </div>

        <!-- Cuarta fila -->
    <div class="info-row" *ngIf="beneficiario?.usuarioValidacion || beneficiario?.usuarioFinalizacion">
      <div class="info-field" *ngIf="beneficiario?.usuarioValidacion && beneficiario?.usuarioValidacion?.length! > 0">
        <span class="field-label">Actualizado por:</span>
        <span class="field-value">
          {{ beneficiario?.usuarioValidacion || 'N/A' }}
        </span>
      </div>
      
      <div class="info-field" *ngIf="beneficiario?.usuarioFinalizacion && beneficiario?.usuarioFinalizacion?.length! > 0">
        <span class="field-label">Finalizado por:</span>
        <span class="field-value">
          {{ beneficiario?.usuarioFinalizacion || 'N/A' }}
        </span>
      </div>
    </div>
  </div>

  <hr class="divider">
    <div class="acciones-section" *ngIf="isVisible">
        <h3 class="section-title">Baja del Beneficio Gestante</h3>
        
        <div class="fecha-finalizacion-container">
          <p style="margin-bottom: 15px; font-weight: 500;">Por favor seleccione la fecha de finalización:</p>
          <nz-date-picker 
            [(ngModel)]="fechaFinalizacion"
            nzFormat="yyyy-MM-dd"
            nzPlaceHolder="Seleccionar fecha de finalización"
            [nzAllowClear]="false"
            style="width: 100%;"
            [nzDisabledDate]="disabledDate"
            class="red-date-picker">
          </nz-date-picker>
          
          <div class="botones-finalizacion">
            <button 
              nz-button 
              nzType="primary"
              class="excel-button boton-añadir"
              (click)="confirmarBajaBeneficiario()" 
              [nzLoading]="isConfirmLoading">
              Aceptar
            </button>
          </div>
        </div>
    </div>

  <div class="archivos-section">
    <h3 class="archivos-titulo">Archivos</h3>
    
    <div class="archivos-scroll-container">
      <div class="archivo-item" *ngFor="let archivo of getarchivos(beneficiario?.archivos)" (click)="verArchivo(archivo)">
        <img [src]="getArchivoIcon(archivo.tipo)" alt="Archivo" class="archivo-icon">
        <span class="archivo-nombre">{{ archivo.nombre }}</span>
      </div>
      
      <div class="no-archivos" *ngIf="getarchivos(beneficiario?.archivos).length === 0">
        <nz-empty 
          nzNotFoundImage="simple" 
          nzNotFoundContent="No hay archivos disponibles">
        </nz-empty>
      </div>
    </div>
  </div>

  <hr class="divider">

  <div class="acciones-section" *ngIf="user?.esMedico && !beneficiario?.esProcesada && !beneficiario?.esVigente">
    <h3 class="section-title">¿ Deseas aprobar o rechazar esta solicitud?</h3>

    <div class="acciones-container">
      
      <div class="botones-accion">
        <button 
          nz-button 
          nzType="primary" 
          nzDanger
          class="boton-rechazar"
          (click)="rechazarSolicitud()"
          [nzLoading]="procesando">
          <i nz-icon nzType="close"></i>
          Rechazar
        </button>
        
        <button 
          nz-button 
          nzType="primary"
          class="boton-aprobar"
          (click)="aprobarSolicitud()"
          [nzLoading]="procesando">
          <i nz-icon nzType="check"></i>
          Aprobar
        </button>
      </div>
    </div>
  </div>

  </nz-spin>
</div>
